import { render, staticRenderFns } from "./HistoryMenu.vue?vue&type=template&id=27f79b64&scoped=true&"
import script from "./HistoryMenu.vue?vue&type=script&lang=ts&"
export * from "./HistoryMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryMenu.vue?vue&type=style&index=0&id=27f79b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f79b64",
  null
  
)

export default component.exports